'use client'
import {
  PasswordInput as MantinePasswordInput,
  PasswordInputProps,
} from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { RiEyeCloseLine, RiEyeLine } from '@remixicon/react'

export const PasswordInput = (props: PasswordInputProps) => {
  const [visible, { toggle }] = useDisclosure(false)
  return (
    <MantinePasswordInput
      rightSection={
        visible ? (
          <RiEyeLine size={17} onClick={toggle} style={{ cursor: 'pointer' }} />
        ) : (
          <RiEyeCloseLine
            size={17}
            onClick={toggle}
            style={{ cursor: 'pointer' }}
          />
        )
      }
      visible={visible}
      onVisibilityChange={toggle}
      {...props}
    />
  )
}
